export default function ArtgCont({conteudo}){
    return(
        <div className="main-article-content">
            <p>{conteudo}</p>
        </div>
    );
}